import {
  Wrench,
  Zap,
  Hammer,
  HardHat,
  Sparkles,
  Scissors,
  GraduationCap,
  Sprout,
  Droplets,
  Snowflake,
  Shirt,
  Cctv,
  Flame,
  Car,
  CarTaxiFront,
  ShoppingBag,
  Wrench as Fallback,
} from "lucide-react";

const MAP = {
  Wrench,
  Zap,
  Hammer,
  HardHat,
  Sparkles,
  Scissors,
  GraduationCap,
  Sprout,
  Droplets,
  Snowflake,
  Shirt,
  Cctv,
  Flame,
  Car,
  CarTaxiFront,
  ShoppingBag,
};

export const getServiceIcon = (name) => MAP[name] || Fallback;
